import {
  BorderRadius,
  BorderTopLeftRadius,
  BorderTopRightRadius,
  BorderBottomLeftRadius,
  BorderBottomRightRadius,
  BorderRadiusBase,
  CssVariable,
} from '@wix/css-property-parser';

/**
 * Physical atomics from border-radius shorthand.
 * Note: Logical properties (borderStartStartRadius, etc.) are NOT atomics of border-radius.
 * They are separate CSS properties (siblings for grouping), not part of shorthand decomposition.
 */
export type CornerParsedValue = {
  borderTopLeftRadius: string | null;
  borderTopRightRadius: string | null;
  borderBottomLeftRadius: string | null;
  borderBottomRightRadius: string | null;
};

export const parseCornerValue = (value: string): CornerParsedValue => {
  const borderRadius = BorderRadius.parse(value);

  const values: CornerParsedValue = {
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
  };

  if (!borderRadius) {
    return values;
  }

  if ('type' in borderRadius && borderRadius.type === 'variable') {
    Object.keys(values).forEach((key) => {
      values[key as keyof CornerParsedValue] =
        CssVariable.toCSSValue(borderRadius);
    });

    return values;
  }

  if (
    'borderTopLeftRadius' in borderRadius &&
    borderRadius.borderTopLeftRadius
  ) {
    values.borderTopLeftRadius = BorderTopLeftRadius.toCSSValue(
      borderRadius.borderTopLeftRadius as BorderRadiusBase,
    );
  }
  if (
    'borderTopRightRadius' in borderRadius &&
    borderRadius.borderTopRightRadius
  ) {
    values.borderTopRightRadius = BorderTopRightRadius.toCSSValue(
      borderRadius.borderTopRightRadius as BorderRadiusBase,
    );
  }
  if (
    'borderBottomLeftRadius' in borderRadius &&
    borderRadius.borderBottomLeftRadius
  ) {
    values.borderBottomLeftRadius = BorderBottomLeftRadius.toCSSValue(
      borderRadius.borderBottomLeftRadius as BorderRadiusBase,
    );
  }
  if (
    'borderBottomRightRadius' in borderRadius &&
    borderRadius.borderBottomRightRadius
  ) {
    values.borderBottomRightRadius = BorderBottomRightRadius.toCSSValue(
      borderRadius.borderBottomRightRadius as BorderRadiusBase,
    );
  }

  return values;
};
